import { render, staticRenderFns } from "./AssetModelTable.vue?vue&type=template&id=5978158a&scoped=true&"
import script from "./AssetModelTable.vue?vue&type=script&lang=js&"
export * from "./AssetModelTable.vue?vue&type=script&lang=js&"
import style0 from "./AssetModelTable.vue?vue&type=style&index=0&id=5978158a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5978158a",
  null
  
)

export default component.exports